import React from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import * as r from "../../js/constants/routes";
import { SelectURLGrid } from "../Widgets/Custom Inputs/Select";
import { requiredCell } from "../../js/utils/inputValidations";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import { filterValidUser } from "./cst_DataGrid";
import { ListItem, ListItemText } from "@mui/material";
import { useSelector } from "react-redux";

const GISManagerGrid = ({ label = t("grid.title.GISManagers"), baseURL }) => {
    const apiRef = useGridApiRef();
    const { HoldingManager } = useSelector(state => state.auth);
    const cellFocusField = "OTUser_select";

    const gridSpecificColumns = [
        {
            field: "OTUser_IGG",
            headerName: "IGG",
            sortable: false,
            flex: 0.5,
            valueGetter: params => params.row.OTUser_select?.IGG,
        },
        {
            field: "OTUser_select",
            headerName: t("field.User"),
            sortable: false,
            flex: 1,
            editable: true,
            valueFormatter: params => params.value?.Name,
            renderEditCell: params => {
                return (
                    <SelectURLGrid
                        fieldName={"OTUserID"}
                        paramURL={filterValidUser}
                        selectRoute={"SelectDetail"}
                        URL={r.oTUser}
                        getOptionLabel={option => option.Name ?? option.IGG}
                        filterOptions={options => options}
                        renderOption={(props, option) => (
                            <ListItem {...props} key={option.ObjectID}>
                                <ListItemText
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    inset
                                    primary={option.Name}
                                    secondary={option.IGG}
                                />
                            </ListItem>
                        )}
                        {...params}
                    />
                );
            },
            preProcessEditCellProps: params => {
                const hasError = requiredCell(
                    params,
                    apiRef,
                    "User",
                    "OTUser_select"
                );
                return { ...params.props, error: hasError };
            },
            valueSetter: params => ({
                ...params.row,
                EMail: params.value.EMail,
            }),
        },
        {
            field: "OTUserID",
            editable: false,
        },
        {
            field: "EMail",
            headerName: "Email",
            sortable: false,
            flex: 0.5,
            valueGetter: params => params.row.OTUser_select?.EMail,
        },
        {
            field: "OTEntityID",
            valueGetter: params => params.row?.OTEntity_select?.ObjectID,
        },
    ];

    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={baseURL}
            cellFocusField={cellFocusField}
            columnVisibilityModel={{
                OTUserID: false,
                OTEntityID: false,
            }}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            isEditDisabled={true}
            isAddDisabled={HoldingManager ? true : false}
            initialState={{
                sorting: {
                    sortModel: [{ field: "OTUserID", sort: "asc" }],
                },
            }}
        />
    );
};

export default GISManagerGrid;
